(function ($, window, document) {
	var $win = $(window);
	var $doc = $(document);
	var $body = $('body');
	var $html = $('html');

	$doc.ready(function () {
		//Slider Autoplay observers
		const observers = {};

		function startAutoplayForSlider(sliderClass) {
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && window_width() < 768) {
						$(`.${sliderClass}`).slick('slickPlay');
						observer.unobserve(entry.target);
					}
				});
			});

			const sliderElements = document.querySelectorAll(`.${sliderClass}`);
			sliderElements.forEach((element) => {
				observer.observe(element);
			});

			observers[sliderClass] = observer;
		}

		//Cards slider

		$('.js-slider-cards').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			infinite: false,
			autoplaySpeed: 3000,
			pauseOnHover: true,
			pauseOnFocus: true,
			swipeToSlide: true,
			touchThreshold: 20,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						variableWidth: true,
						dots: true,
						infinite: false,
						autoplay: false,
						pauseOnFocus: true,
						arrows: false,
						touchThreshold: 500,
					}
				}
			],
		});

		startAutoplayForSlider('js-slider-cards');


		//Medium cards slider
		$win.on('load resize', function () {
			$('.js-slider-cards-medium').each(function () {
				const $this = $(this);

				if ($this.length && !$this.hasClass('slick-initialized')) {
					$this.slick({
						mobileFirst: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						autoplaySpeed: 6000,
						pauseOnFocus: true,
						autoplay: false,
						touchThreshold: 500,
						variableWidth: true,
						infinite: false,
						arrows: false,
						responsive: [
							{
								breakpoint: 767,
								settings: 'unslick'
							}
						],
					});

					startAutoplayForSlider('js-slider-cards-medium');
				}
			});
		});

		// Articles Slider
		let articleSliders = $('.js-slider-articles');

		articleSliders.slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: false,
			arrows: false,
			autoplaySpeed: 3000,
			swipeToSlide: true,
			touchThreshold: 100,
			swipe: true,
			pauseOnHover: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true,
						dots: true,
						autoplaySpeed: 6000,
						pauseOnFocus: true,
						autoplay: false,
						arrows: true,
						touchThreshold: 500,
					}
				}
			],
		});

		// startAutoplayForSlider('js-slider-articles');

		//Related content
		$('.js-slider-cards-related').slick({
			// mobileFirst: true,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: false,
			autoplaySpeed: 6000,
			variableWidth: false,
			dots: false,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					},
				}
			],
		});

		startAutoplayForSlider('js-slider-cards-related');


		//Cards Mobile
		$('.js-slider-cards-mobile').slick({
			mobileFirst: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplaySpeed: 6000,
			variableWidth: false,
			dots: true,
			responsive: [
				{
					breakpoint: 767,
					settings: 'unslick'
				}
			],
		});

		startAutoplayForSlider('js-slider-cards-mobile');


		//History slider

		$('.js-slider-history .slider__slides').slick({
			slidesToShow: 1,
			swipe: true,
			swipeToSlide: true,
			arrows: false,
			dots: false,
			infinite: false,
		})


		//Click trought - change slide
		$doc.on('click', '.js-slider-cards, .js-slider-cards-related, .js-slider-cards-mobile, .js-slider-articles, .js-slider-gallery-slides, .js-slider-full-width, js-slider-gallery-slides, .js-slider-testimonials', function (e) {
			if (!$(e.target).is('a') && window_width() > 1023) {
				const $slider = $(this).closest('.js-slider-cards, .js-slider-cards-related, .js-slider-cards-mobile, .js-slider-articles, .js-slider-gallery-slides, .js-slider-full-width, js-slider-gallery-slides, .js-slider-testimonials');
				const slideWidth = $slider.outerWidth();
				const middle = slideWidth / 2;

				const clickX = e.pageX - $slider.offset().left;

				if (clickX < middle) {
					$slider.slick('slickPrev');
				} else {
					$slider.slick('slickNext');
				}
			}
		});

		$('.js-slider-cta').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						adaptiveHeight: true,
					}
				}
			]
		});

		$('.js-slider-hero').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 800,
			fade: true,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
			swipe: false,
			draggable: false,
			touchMove: false,
		});

		var $wrapperSlider = $('.js-slider-text-media'),
			wrapperSlider = $wrapperSlider[0];

		$('.js-slider-text-media').slick({
			mobileFirst: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			variableWidth: false,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 767,
					settings: 'unslick'
				}
			],
		})

		$('.js-slider-gallery').each(function () {
			$slider = $(this);

			const $slides = $slider.find('.js-slider-gallery-slides');
			const isFadeSlider = Boolean($slides.data('fade'));

			const optionsDefault = {
				arrows: isFadeSlider,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							centerMode: true,
							// variableWidth: true
						}
					}
				]
			}

			let options = {};

			if (isFadeSlider) {
				options = $.extend({}, {
					infinite: false,
					speed: 0,
					fade: true,
					cssEase: 'linear',
					// arrows: true,
					prevArrow: $slider.find('.slider__prev'),
					nextArrow: $slider.find('.slider__next'),
				}, optionsDefault);
			} else {
				options = $.extend({}, {
					autoplay: true,
					autoplaySpeed: 4000,
				}, optionsDefault);
			}

			$slides
				.slick(options)
				.on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
					updateSliderCounter($(this), slick, nextSlide + 1);

					const $sliderSlides = slick.$slides;
				})
				.on('afterChange', function (event, slick, currentSlide) {
					if (wrapperSlider && window_width() < 768) {
						wrapperSlider.slick.setOption({
							swipe: true
						});
					}

					const $sliderSlides = slick.$slides;

					if (isFadeSlider) {
						setTimeout(function () {
							$sliderSlides.slice(0, currentSlide).css('opacity', 1);
							$sliderSlides.slice(0, currentSlide).css('transition', 'opacity 0s');
							$sliderSlides.slice(currentSlide + 1).css('opacity', 0);
							$sliderSlides.eq(currentSlide).css('opacity', 1);
						}, 4);
					}

				})
		});


		let slickArrowTimeout;
		$('.slider-stacked-gallery').on('click', '.slick-arrow', function (event) {
			const $this = $(this);

			$this.addClass('is-clicked');
			$this.siblings().removeClass('is-clicked');

			clearTimeout(slickArrowTimeout);

			slickArrowTimeout = setTimeout(function () {
				$this.removeClass('is-clicked')
			}, 800);
		});

		function updateSliderCounter(slider, slick, currentSlide) {
			const $sliderGallery = slider.closest('.js-slider-gallery');
			const $counter = $sliderGallery.find('.js-slider-paging');
			var currentIndex = currentSlide;
			const totalSlides = slick.slideCount;

			$counter.text(`${currentIndex.toString()}/${totalSlides.toString()}`);
		}

		$('.js-slider-full-width').slick({
			centerMode: true,
			infinite: true,
			slidesToShow: 1,
			variableWidth: true,
			pauseOnFocus: true,
			draggable: true,
			speed: 600,
			arrows: false,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						variableWidth: false,
						autoplaySpeed: 6000,
						autoplay: true,
						arrows: false,
					}
				}
			]
		});

		$('.js-slider-gallery').on('mousedown touchstart', function () {
			if (window_width() < 768) {
				wrapperSlider.slick.setOption({
					swipe: false
				});
			}
		})


		$('.js-slider-testimonials').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			autoplay: true,
			autoplaySpeed: 5000,
		});


		$('.js-expandable-text').each(function () {
			const expandableText = this;
			const content = expandableText.querySelector('.js-expandable-text-content');
			const button = expandableText.querySelector('.js-expandable-text-button');

			button.addEventListener("click", (e) => {
				content.style.height = content.clientHeight + "px";

				expandableText.classList.add("is-active");
				
                content.style.height = content.scrollHeight + "px";

				content.addEventListener("transitionend", () => {
					content.style.removeProperty("height");
				}, { once: true }
				);
			});
		});

		sliderBoxes();
		scaleLogoOnScroll();
		heroCtaShiftUp();
		showGalleryImages();
		headerSolidBg();
		stickySubmenu();
		navSubmenuOpen();
		navToggle();

		$('.js-custom-select').selectric({
			disableOnMobile: false,
			nativeOnMobile: false,
			multiple: {
				keepMenuOpen: true,
			},
			labelBuilder: '{text}',
			onBeforeOpen: function () {
				var wrp = this.closest('.selectric-wrapper');
				var fixer = wrp.getElementsByClassName('selectric-items')[0];

				if (window_width() < 1023) {
					$(fixer).stop(true, true).slideDown();
				}

			},
			onClose: function (element, event) {
				var wrp = this.closest('.selectric-wrapper');
				var fixer = wrp.getElementsByClassName('selectric-items')[0];

				if (window_width() < 1023) {
					$(fixer).css('display', 'block');
					$(fixer).stop(true, true).show().slideUp();
				}
			},
		});

		$('.js-venues-filters').on('selectric-change', function () {
			var filters = {};

			$('.js-venues-filters').each(function () {
				var $this = $(this);
				filters[$this.attr('id')] = $(this).val();
			});

			$.ajax({
				type: 'post',
				dataType: 'json',
				url: main_theme.ajax_url,
				data: {
					action: 'get_filters_venues_count',
					filters: filters,
				},
				success: function (response) {
					if (response.success) {
						$('.js-venues-count').removeClass('hidden-mobile').text(response.data.count);
					}
				}
			})
		});

		$('.form select').selectric({
			disableOnMobile: false,
			nativeOnMobile: false,
			onOpen: function () {
				var wrp = this.closest('.selectric-wrapper');
				var fixer = wrp.getElementsByClassName('selectric-items')[0];
				fixer.style.display = 'none';
				fixer.offsetHeight; // no need to store this anywhere, the reference is enough
				fixer.style.display = 'block';
			},
			onClose: function () {
				var wrp = this.closest('.selectric-wrapper');
				var fixer = wrp.getElementsByClassName('selectric-items')[0];
				fixer.style.display = 'none';
			}
		});

		$doc.on('gform_post_render', function (event, index) {
			$('.form select').selectric({
				disableOnMobile: false,
				nativeOnMobile: false,
				onOpen: function () {
					var wrp = this.closest('.selectric-wrapper');
					var fixer = wrp.getElementsByClassName('selectric-items')[0];
					fixer.style.display = 'none';
					fixer.offsetHeight; // no need to store this anywhere, the reference is enough
					fixer.style.display = 'block';
				},
				onClose: function () {
					var wrp = this.closest('.selectric-wrapper');
					var fixer = wrp.getElementsByClassName('selectric-items')[0];
					fixer.style.display = 'none';
				}
			});

			$('.js-custom-select').selectric({
				disableOnMobile: false,
				nativeOnMobile: false,
				multiple: {
					keepMenuOpen: true,
				},
				labelBuilder: '{text}',
				onBeforeOpen: function () {
					var wrp = this.closest('.selectric-wrapper');
					var fixer = wrp.getElementsByClassName('selectric-items')[0];

					if (window_width() < 1023) {
						$(fixer).stop(true, true).slideDown();
					}

				},
				onClose: function (element, event) {
					var wrp = this.closest('.selectric-wrapper');
					var fixer = wrp.getElementsByClassName('selectric-items')[0];

					if (window_width() < 1023) {
						$(fixer).css('display', 'block');
						$(fixer).stop(true, true).show().slideUp();
					}
				},
			});
		});

		$('.js-trigger-popup').on('click', function (event) {
			const $this = $(this);

			$.magnificPopup.open({
				items: {
					src: $this.attr('href'),
					type: $this.data('type') || 'image',
				},
				closeBtnInside: false,
				iframe: {
					patterns: {
						youtube: {
							index: 'youtube.com/',
							id: 'v=',
							src: '//www.youtube.com/embed/%id%?autoplay=1&mute=1'
						},
						vimeo: {
							index: 'vimeo.com/',
							id: '/',
							src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1'
						},
					},
				}
			});

			event.preventDefault();
		});

		var loadingPostsContent = false;

		$doc.on('click', '.js-load-more', function (event) {
			event.preventDefault();

			if (loadingPostsContent) {
				return;
			}

			var $this = $(this);
			$this.hide().siblings('em').show();

			loadingPostsContent = true;
			addSpinner();

			history.pushState(null, null, $this.attr('href'));

			$.ajax({
				url: $this.attr('href'),
				success: function (data) {
					var $posts = $(data).find('.js-list-posts');
					var $loadMore = $(data).find('.js-load-more');
					var $pagination = $(data).find('.js-pagination');

					if ($posts.length) {
						$doc.find('.js-list-posts').html($posts.html());
					}

					if ($loadMore.length) {
						$this.show().attr('href', $loadMore.attr('href'));
						$this.siblings('em').hide();
					} else {
						$this.parent().hide();
					}

					if ($pagination.length) {
						$doc.find('.js-pagination').html($pagination.html());
					}
				},
				error: function (errorThrown) {
					console.log(errorThrown);
				},
				complete: function () {
					loadingPostsContent = false;
					removeSpinner();
				}
			});
		});

		$doc.on('click', '.js-filters-clear, .js-pagination a', function (event) {
			event.preventDefault();

			if (loadingPostsContent) {
				return;
			}

			loadingPostsContent = true;
			addSpinner();

			$.ajax({
				url: $(this).attr('href'),
				success: function (data) {
					var $content = $(data).find('.js-section-posts-content');

					if ($content.length) {
						$doc.find('.js-section-posts-content').html($content.html());
					}
				},
				error: function (errorThrown) {
					console.log(errorThrown);
				},
				complete: function () {
					loadingPostsContent = false;
					removeSpinner();
				}
			});
		});
	});

	function addSpinner() {
		$body.append('<div class="js-ajax-spinner ajax-spinner"></div>');
	}

	function removeSpinner() {
		$doc.find('.js-ajax-spinner').remove();
	}

	function sliderBoxes() {
		const sliderBoxesSettings = {
			mobileFirst: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 1024,
					settings: 'unslick'
				}
			],
		};

		const $sliderBoxes = $('.js-slider-boxes').slick(sliderBoxesSettings);

		$(window).on('resize orientationChange', function (event) {
			if ($win.width() > 1023) {
				return;
			}

			if ($sliderBoxes.hasClass('slick-initialized')) {
				return;
			}

			$sliderBoxes.slick(sliderBoxesSettings);
		});
	}

	function scaleLogoOnScroll() {
		const $logo = $('.js-logo-large');

		if (!$logo.length) {
			return;
		}

		const scrollThreshold = 200;
		const minLogoWidth = 164;

		const $wpadminbar = $('#wpadminbar');
		const $header = $('.js-header');

		function scaleLogo() {
			requestAnimationFrame(function () {
				const headerTop = $header.offset().top - ($wpadminbar.height() || 0);
				let scaleFactor = Math.max(1 - ($win.scrollTop() / scrollThreshold), minLogoWidth / $logo.width());

				$logo.css('transform', `scale(${scaleFactor})`);
				$header.toggleClass('header-hidden', headerTop <= scrollThreshold);
			});
		}

		$win.on('scroll', scaleLogo);
		$win.on('resize', scaleLogo);
		$win.on('load', scaleLogo);
	}

	function heroCtaShiftUp() {
		const $heroCtaText = $('.js-hero-cta-text');
		if (!$heroCtaText.length) {
			return;
		}

		$heroCtaText.addClass('up');
	}

	function showGalleryImages() {
		if (window_width() > 767) {
			const $galleryImages = $('.js-gallery-images');
			let galleryAnimated = false;

			if (!$galleryImages.length) {
				return;
			}

			$win.on('scroll', function () {
				if (galleryAnimated) {
					return;
				}

				const galleryTop = $galleryImages.offset().top;
				const galleryHalfHeight = $galleryImages.height() / 2;

				if ($win.scrollTop() < (galleryTop + galleryHalfHeight)) {
					return;
				}

				galleryAnimated = true;

				$galleryImages.find('.gallery__image').each(function (i) {
					const delay = 250 * i;
					const $this = $(this);

					setTimeout(function () {
						$this.addClass('animated');
					}, delay);
				});
			});
		}
	}

	function headerSolidBg() {
		const $header = $('.header');
		const $hero = $(`.hero:not(.hero--dark)`);
		const $wpadminbar = $('#wpadminbar');
		$header.attr('data-has-white-bg', $header.hasClass('header--white'));
		const heroMinHeight = 0;
		const hasWhiteBg = $header.attr('data-has-white-bg') || 'false';

		let scrollTop = $win.scrollTop() + ($header.height() || 0) + ($wpadminbar.height() || 0);
		let heroPositionBottom = ($hero.offset()?.top || 0) + ($hero.height() || heroMinHeight);
		let toggleClass = hasWhiteBg == 'true' ? 'header--solid-bg' : 'header--white header--solid-bg';
		let afterHero = scrollTop > heroPositionBottom;

		$header.attr('data-has-solid-bg', afterHero);

		$win.on('scroll load', function () {
			// requestAnimationFrame(function() {
			scrollTop = $win.scrollTop() + ($header.height() || 0) + ($wpadminbar.height() || 0);
			heroPositionBottom = ($hero.offset()?.top || 0) + ($hero.height() || heroMinHeight);

			toggleClass = hasWhiteBg == 'true' ? 'header--solid-bg' : 'header--white header--solid-bg';
			afterHero = scrollTop > heroPositionBottom;

			$header.attr('data-has-solid-bg', afterHero);

			if ($('.menu-item-open').length) {
				return;
			}

			$header.toggleClass(toggleClass, afterHero);
			// });
		});

		if ($('.menu-item-open').length) {
			return;
		}

		$header.toggleClass(toggleClass, afterHero);
	}

	$win.on('scroll resize load', function (event) {
		const $header = $('.header');
		const $hero = $(`.hero:not('.hero--dark'), .hero.hero--alt`);
		const $wpadminbar = $('#wpadminbar');
		const heroMinHeight = 0;

		const scrollTop = $win.scrollTop() + ($header.height() || 0) + ($wpadminbar.height() || 0);
		const heroPositionBottom = ($hero.offset()?.top || 0) + ($hero.height() || heroMinHeight);
		const afterHeroTotal = scrollTop > heroPositionBottom + $header.height();

		$('.hero--full, .hero--alt').toggleClass('is-past', afterHeroTotal);
	});

	function stickySubmenu() {
		const $submenu = $('.js-sticky-submenu');
		const $wpadminbar = $('#wpadminbar');
		const $header = $('.header');

		if (!$submenu.length) {
			return;
		}

		$submenu.data('top', $submenu.offset().top);

		const submenuOffset = ($wpadminbar.height() || 0) + ($header.height() || 0);

		$win.on('scroll', function () {
			requestAnimationFrame(function () {
				// $submenu.toggleClass('fixed', $win.scrollTop() > ($submenu.data('top') - submenuOffset));
			});
		});
	}

	function navSubmenuOpen() {
		const $header = $('.header');

		$('.menu-item-has-children > a').on('click', function (event) {
			if (!$(this).parent().hasClass('menu-item-open') && window_width() < 1024) {
				event.preventDefault();

				$(this).parent('.menu-item-has-children').addClass('menu-item-open');
				$(this).siblings('.sub-menu').stop().slideDown();
			}

			$(this).parent('.menu-item-has-children').siblings('.menu-item-open').removeClass('menu-item-open').find('.sub-menu').slideUp();
		});

		$('.menu-item-has-children').mouseover(function (event) {
			if (window_width() > 1023) {
				const hasSolidBg = $header.attr('data-has-solid-bg') || 'false';

				if (hasSolidBg == 'false' && !$header.hasClass('header--solid-bg')) {
					$header.addClass('header--white header--solid-bg');
				}
			}
		});

		$('.menu-item-has-children').mouseleave(function (event) {
			if (window_width() > 1023) {
				const hasSolidBg = $header.attr('data-has-solid-bg') || 'false';

				const removeClass = hasSolidBg == 'true' ? '' : 'header--white header--solid-bg';
				$header.removeClass(removeClass);
			}
		});
	}

	let showItemsInterval;
	let hideItemsInterval;

	function disableNavToggle() {
		$('.js-nav-toggle').css('pointer-events', 'none');
	}

	function enableNavToggle() {
		$('.js-nav-toggle').css('pointer-events', 'auto');
	}

	function navToggle() {
		$('.js-nav-toggle').on('click', function (event) {
			event.preventDefault();

			var $header = $('.header-tcc').length ? $('.header-tcc') : $('.header');
			var $btn = $(this);
			var isOpen = $header.hasClass('nav-open');

			$header.toggleClass('nav-open');
			$('body').toggleClass('nav-open');
			$btn.attr('aria-expanded', !isOpen);
		});
	}

	//Check user interaction/activity and toggle logo size  
	let hasInteracted = false;

	$win.on('scroll', function (event) {
		hasInteracted = !hasInteracted;
	});

	function toggleLargeLogoOnTimeout(timeoutValue) {
		setTimeout(function () {
			if (!hasInteracted) {
				$('.js-header').addClass('header--timeout');
				$('.js-header').css('transition', 'border .6s .6s, background-color .3s, opacity .6s');

				const $logo = $('.js-logo-large');

				if (!$logo.length) {
					return;
				}

				const scrollThreshold = 200;
				const minLogoWidth = 164;

				$logo.css('--scale-factor', `${minLogoWidth / $logo.width()}`);

				$win.on('resize', function (event) {
					$logo.css('--scale-factor', `${minLogoWidth / $logo.width()}`);
				});

				$win.on('scroll', function (event) {
					$('.js-header').css('transition', 'border .6s, background-color .3s, opacity .6s');
				});
			}
		}, timeoutValue);
	}

	//Set Mutation Observer on slick-dots to sync with active slides
	// void
	function syncSlickDotsWithSlides() {
		const config = { attributes: true, subtree: true, attributeFilter: ['class'] };

		const callback = function (mutationsList, observer) {
			mutationsList.forEach(function (mutation) {
				const $mutationTarget = $(mutation.target)

				if (mutation.type === 'attributes'
					&& mutation.attributeName === 'class'
					&& $mutationTarget.hasClass('slick-active')) {
					$mutationTarget.parent()
						.stop()
						.animate({
							scrollLeft: $mutationTarget.parent().scrollLeft()
								+ $mutationTarget.position().left
								- $mutationTarget.outerWidth(true)
								- parseInt($mutationTarget.css('padding-left'))
						}, 500);
				}
			});
		};

		$('.slick-dots').each(function () {
			if (!$(this).data('mutationObserverSet')) {
				let observer = new MutationObserver(callback);

				observer.observe(this, config);

				$(this).data('mutationObserverSet', true);
			}
		});
	}

	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}

	//Calc dvh
	let dvh = window.innerHeight * 0.01;
	let dvw = $('body').innerWidth();

	document.documentElement.style.setProperty('--dvh', `${dvh}px`);
	document.documentElement.style.setProperty('--dvw', `${dvw}px`);
	document.documentElement.style.setProperty('--current-dvh', `${window.innerHeight * 0.01}px`);

	$(window).on('resize', function (event) {
		document.documentElement.style.setProperty('--current-dvh', `${window.innerHeight * 0.01}px`);

		if ($('body').innerWidth() != dvw) {
			dvh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--dvh', `${dvh}px`);
			dvw = $('body').innerWidth();
			document.documentElement.style.setProperty('--dvw', `${dvw}px`);
		}
	});

	//Calc header height
	$html.css('--header-current-height', ($('.header-tcc').outerHeight() || $('.header').outerHeight()) + 'px');

	$(window).on('resize', function (event) {
		$html.css('--header-current-height', ($('.header-tcc').outerHeight() || $('.header').outerHeight()) + 'px');
	});

	//Calc footer height
	$html.css('--footer-current-height', $('.footer').outerHeight() + 'px');

	$(window).on('resize', function (event) {
		$html.css('--footer-current-height', $('.footer').outerHeight() + 'px');
	});


	function handleFixedNav() {
		const $fixedNav = $('.js-sticky-submenu');

		if ($fixedNav.length) {
			const navSecondaryHeight = $fixedNav.find('.container').outerHeight();

			$fixedNav.css('--nav-height', `${navSecondaryHeight}px`);
			$html.css('--subnav-height', `${navSecondaryHeight}px`)
		}
	}

	function handleFixedEl() {
		const $fixedNav = $('.js-sticky-submenu');

		if ($fixedNav.length > 0) {
			const $fixedNavTop = $fixedNav.offset().top;

			if ($win.scrollTop() + $('.header').outerHeight(true) >= $fixedNavTop) {
				$fixedNav.addClass('is-fixed')
			} else {
				$fixedNav.removeClass('is-fixed')
			}
		}
	}

	$win.on('load scroll', function () {
		handleFixedEl();
	})

	$win.on('load resize', function () {
		handleFixedNav();
	})

	$win.on('load resize orientationChange', function () {
		syncSlickDotsWithSlides();
	});

	$doc.on("gform_confirmation_loaded", function (e, form_id) {
		$('.gform_confirmation_message').closest('.form').find('.form__gallery').show();
	});


	//Size down large logo on 3 second inactivity
	const maximumNoInteractionTime = 3000; //ms

	if (!document.hidden) {
		toggleLargeLogoOnTimeout(5000);
	} else {
		$doc.one('visibilitychange', function (event) {
			toggleLargeLogoOnTimeout(5000);
		});
	}


	//Search
	$('.js-toggle-search').on('click', function (event) {
		event.preventDefault();

		$('.search-form').toggleClass('is-open');
	});


	//Lottie
	function loadLottie() {
		const lottieAnim = document.querySelectorAll('.js-lottie');

		lottieAnim.forEach(function (el) {
			let anim = lottie.loadAnimation({
				container: el,
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: el.dataset.src,
			});

			anim.setSpeed(0.9);

			$win.on('load scroll', function () {
				const scrollPos = $win.scrollTop();
				const winSizePos = scrollPos + $win.outerHeight();
				const elPos = $(el).offset().top;
				const elFullSize = $(el).offset().top + $(el).outerHeight();
				if (scrollPos < elFullSize && winSizePos > elFullSize) {
					anim.play();
				};
			});
		});
	};

	loadLottie();

	//Google maps
	function loadAjax(filePath) {
		var response;

		$.ajax({
			'async': false,
			'global': false,
			'url': filePath,
			'dataType': 'json',
			'success': function (data) {
				response = data;
			},
			'error': function (xhr, status, error) {
				console.error('Error loading JSON: ' + error);
			}
		});

		return response;
	}

	let map;

	function initMap() {
		if (!$('#map').length) {
			return
		}

		$('.map').each(function () {
			var $map = $(this)
			var map;
			// var iBox;
			var mapMarkers = $map.data('markers');
			const centerLat = parseFloat($map.data('lat'));
			const centerLng = parseFloat($map.data('lng'));
			const zoom = parseInt($map.data('zoom'));

			var mapData = {
				"mapOptions": {
					"center": {
						"lat": centerLat,
						"lng": centerLng
					},
					"zoom": zoom,
					"mapTypeControl": false,
					"zoomControl": false,
					"streetViewControl": false,
					"fullscreenControl": false,
				},
			}
			var markers = [];
			var content;

			map = new google.maps.Map($map.get(0), mapData.mapOptions);

			if (!mapMarkers || typeof mapMarkers == 'undefined') {
				// Create single marker at map center if no markers provided
				marker = new google.maps.Marker({
					position: {
						lat: centerLat,
						lng: centerLng
					},
					map: map
				});
				markers.push(marker);
				return;
			}

			var markersObj = loadAjax(mapMarkers).markers;
			for (var i = 0; i < markersObj.length; i++) {
				marker = new google.maps.Marker({
					position: markersObj[i].position,
					map: map,
				});

				markers.push(marker);
			}
		})
	}

	//Popup
	$('.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true,
		fixedContentPos: true,
		callbacks: {
			open: function () {
				setTimeout(function () {
					$('.mfp-wrap').addClass('popup--open');
				}, 50);
				// initMap();
			},
		}
	});

	$('.popup-video').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true,
		fixedContentPos: true,
		callbacks: {
			open: function () {
				setTimeout(function () {
					$('.mfp-wrap').addClass('popup--open');
				}, 50);

				initVideos();
			}
		}
	})

	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

	$(document).mouseup(function (e) {
		var container = $(".popup__inner");

		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$.magnificPopup.close();
		}
	});

	/*
	* Plyr
	 */
	function initVideos() {
		const players = Array.from(document.querySelectorAll(".js-media-video"))

		players.map(function (p) {
			const isAutoplay = $(p).closest('.media__video').data('autoplay') == 1;
			const isHover = $(p).closest('.media').data('hover');
			const isIntroScreen = $('.home').length > 0 && $(p).closest('.page-background').length > 0;

			const player = new Plyr(p, {
				volume: 0,
				autoplay: isAutoplay === false || isHover === true || isIntroScreen == true ? false : true,
				autopause: false,
				// controls: isAutoplay === false ? [''] : false,
				hideControls: false,
				muted: true,
				loop: {
					active: isAutoplay === false ? false : true,
				}
			});

			player.toggleControls(isAutoplay === false ? true : false);

			if (isAutoplay === false) {
				$(player.elements.container).siblings('.js-play-btn, .video__media').on('click', function (event) {
					event.preventDefault();
					player.togglePlay();
					player.increaseVolume(50);
				});

				// player.decreaseVolume(100);

				player.on('ended', (event) => {
					player.stop();
				})
			}

			$(player.elements.container).parent().find('.js-mute-btn').each(function () {
				var $this = $(this);
				if (!$this.data('eventAdded')) {
					$this.on('click', function (event) {
						event.preventDefault();
						if ($this.hasClass('is-muted')) {
							player.increaseVolume(100);
							$this.removeClass('is-muted');
						} else {
							player.decreaseVolume(100);
							$this.addClass('is-muted');
						}
					});
					$this.data('eventAdded', true);
				}
			});

			player.on('play', (event) => {
				$(player.elements.container).parent().addClass('is-played')
			});

			player.on('pause', (event) => {
				$(player.elements.container).parent().removeClass('is-played')
			});

			if ($(p.parentNode).closest('.plyr').siblings('.js-fullscreen-btn').length > 0) {
				$(p.parentNode).closest('.plyr').siblings('.js-fullscreen-btn').on('click', function (event) {
					event.preventDefault();
					player.fullscreen.enter();
				});

				player.on('enterfullscreen', function () {
					$(p.parentNode).closest('.media').addClass('media--fullscreen');
					console.log("Entering full screen!");
					player.toggleControls(true);
					$('.plyr').addClass("plyr--fullscreen");
					player.increaseVolume(50);
				});

				player.on('exitfullscreen', function () {
					$(p.parentNode).closest('.media').removeClass('media--fullscreen');
					console.log('Exiting Full Screen!');
					$('.plyr').removeClass("plyr--fullscreen");
					player.decreaseVolume(50);
				});
			}

			let playercontainer = p.parentNode;

			if (isIntroScreen == true) {
				setTimeout(function () {
					player.play();
				}, 1500);
			}

			if (!p.parentNode) {
				//FOR: Reinit after ajax
				playercontainer = p;
			}

			const config = {
				rootMargin: '0px -100px',
				threshold: 0
			}

			const callback = (entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						player.pause();
						player.decreaseVolume(100);
					} else {
						if (isAutoplay != false && isHover != true && isIntroScreen != true) {
							player.play();
							player.decreaseVolume(100);
						}
						player.decreaseVolume(100);
					}
				});
			}

			var observer = new IntersectionObserver(callback, config);

			observer.observe(playercontainer);

			player.on('ready', () => {
				player.decreaseVolume(100);
				observer = new IntersectionObserver(callback, config);
				observer.observe(playercontainer);
			});
		})
	}


	$('.history__point').hover(
		function () {
			// On mouse enter
			$('.history__point').not(this).css('z-index', ''); // Remove z-index from all other .history__point elements
			$(this).css('z-index', '2');
		},
		function () {
			// On mouse leave
			setTimeout(() => {
				$(this).css('z-index', '');
			}, 250);
		}
	);

	function getHeaderOffset() {
		var headerH = $('.header-tcc__nav-bar--pinned').outerHeight()
			|| $('.header-tcc__nav-bar').outerHeight()
			|| $('.header-tcc').outerHeight()
			|| $('.header').outerHeight()
			|| 0;
		var adminH = $('#wpadminbar').outerHeight() || 0;
		return headerH + adminH + 20;
	}

	function scrollToHash(hash) {
		if (!hash) return;
		var $target = $('#' + hash);
		if (!$target.length) {
			$target = $('[data-id="' + hash + '"]');
		}
		if (!$target.length) return;

		var offset = getHeaderOffset();
		var targetTop = $target.offset().top - offset;
		var distance = Math.abs($win.scrollTop() - targetTop);
		var duration = Math.min(Math.max((distance / 1500) * 1000, 400), 1500);

		$('html, body').animate({ scrollTop: targetTop }, duration, 'swing');
	}

	//Scroll restoration
	if ($('.footer').find('.gfield.gfield_error').length > 0) {
		$('html, body').animate({
			scrollTop: $(document).height() - $(window).height()
		}, 0);
	} else {
		if ($('.home').length > 0 && history.scrollRestoration) {
			history.scrollRestoration = "manual";
			window.scrollTo(0, 0);
		}

		var _hash = window.location.hash.substring(1);

		if (_hash.length > 0) {
			setTimeout(function () {
				scrollToHash(_hash);
			}, 300);
		}
	}

	$doc.on('click', 'a[href*="#"]', function (e) {
		var href = $(this).attr('href');
		if (!href) return;

		var hashIndex = href.indexOf('#');
		if (hashIndex === -1) return;

		var hash = href.substring(hashIndex + 1);
		if (!hash) return;

		var linkPath = href.substring(0, hashIndex) || window.location.pathname;
		var currentPath = window.location.pathname;

		if (linkPath === currentPath || linkPath === '' || linkPath === window.location.href.split('#')[0]) {
			e.preventDefault();
			history.pushState(null, null, '#' + hash);
			scrollToHash(hash);
		}
	});

	//On load
	$win.on('load', function (event) {
		initMap();
		initVideos();
		initScrollAnimation();

		AOS.refresh();

		$('.gallery-animated .gallery__image').each(function (index, el) {
			$(this).data('top-cord', $(this).css('top'));
			$(this).data('percentage-cord', Math.random() * 50);
		});
	});


	$win.on('resize', function (event) {
		$('.js-slider-text-media').each(function (index, el) {
			if ($(this).length && !$(this).hasClass('slick-initialized')) {
				$(this).slick({
					mobileFirst: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					variableWidth: false,
					responsive: [
						{
							breakpoint: 767,
							settings: 'unslick'
						}
					],
				})
			}
		});

		$('.js-slider-cards-mobile').each(function (index, el) {
			if ($(this).length && !$(this).hasClass('slick-initialized')) {
				$(this).slick({
					mobileFirst: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					variableWidth: false,
					dots: true,
					responsive: [
						{
							breakpoint: 767,
							settings: 'unslick'
						}
					],
				})
			}
		});
	});

	//Filters menu
	$doc.on('click', '.js-filters-trigger', function (event) {
		event.preventDefault();

		const $this = $(this);

		$this.closest('.form-filters').find('.form__body').toggleClass('is-open');
		$('body').toggleClass('filters-open');
	});

	var loadingFilters = false;

	$doc.on('change', '.js-filters-buttons input', function () {
		$('.js-filters-buttons').closest('form').submit();
	});

	$doc.on('submit', '.js-form-filters', function (event) {
		event.preventDefault();

		var $form = $(this);
		var formAction = $form.attr('action');
		var formData = $form.serialize();

		if (loadingFilters) {
			return;
		}

		loadingFilters = true;
		addSpinner();

		$.ajax({
			url: formAction + '?' + formData,
			success: function (data) {
				var $content = $(data).find('.js-section-posts-content');

				if ($content.length) {
					$doc.find('.js-section-posts-content').html($content.html());
				}
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
			complete: function () {
				loadingFilters = false;
				removeSpinner();
			}
		});
	});

	//Markers unnatended effect
	let copyInterval;
	let removeTimeout;

	function copyMarker() {
		const $originalMarker = $('.marker:not(.is-copy)');
		const $copiedMarkers = $('body .marker.is-copy');

		if ($originalMarker.length > 0 && $copiedMarkers.length < 90 && document.hidden) {
			const $copy = $originalMarker.clone();
			$copy.addClass('is-copy');

			let randomTop = Math.floor(Math.random() * 91);
			let randomLeft = Math.floor(Math.random() * 91);

			$copy.css({
				top: `${randomTop}%`,
				left: `${randomLeft}%`
			});

			$('body').append($copy);
		}
	}

	function removeCopies() {
		const $copiedMarkers = $('.marker.is-copy');
		$copiedMarkers.fadeOut(400, function () {
			$(this).remove();
		});
	}

	function startCopying() {
		copyInterval = setInterval(copyMarker, 50);
	}

	function stopCopying() {
		clearInterval(copyInterval);
	}

	$(document).on('visibilitychange', function () {
		// setTimeout(function() {
		if (document.visibilityState === "hidden") {
			startCopying();
		} else {
			stopCopying();
			removeTimeout = setTimeout(function () {
				removeCopies();
			}, 500);
		}
		// }, 100);
	});

	// if (document.hidden) {
	// 	startCopying();
	// }

	//About photo scatter

	let $gallerySection = $('.js-get-visible-proggres');

	if ($gallerySection.length) {
		let winHeight = $win.outerHeight() - $('.header')?.outerHeight(true) - $('.js-sticky-submenu')?.outerHeight(true);
		let sectionOffset = $gallerySection.offset().top;
		let sectionHeight = $gallerySection.outerHeight();
		let winScrollPosition = $win.scrollTop() + $('.header')?.outerHeight(true) + $('.js-sticky-submenu')?.outerHeight(true);
		let winWidth = window_width();


		let getProgress = () => {
			winHeight = $win.outerHeight() - $('.header')?.outerHeight(true) - $('.js-sticky-submenu')?.outerHeight(true);
			sectionOffset = $gallerySection.offset().top;
			sectionHeight = $gallerySection.outerHeight();
			winScrollPosition = $win.scrollTop() + $('.header')?.outerHeight(true) + $('.js-sticky-submenu')?.outerHeight(true);
			winWidth = window_width();
			let halfGalleryCord = ((winScrollPosition + winHeight) - sectionOffset) / 2;
			let difference = sectionHeight * 0.5;
			var isPastScrollPosition = $('.js-get-visible-proggres').offset().top <= $win.scrollTop() + $win.outerHeight();
			let progress = ((winScrollPosition + winHeight) - sectionOffset) / sectionHeight;

			let progressAfter = ((winScrollPosition + winHeight) - sectionOffset) / sectionHeight;

			(progress > 1) && (progress = 1);

			(progressAfter < 1) && (progressAfter = 1);
			$('.gallery-animated').toggleClass('is-fixed', progressAfter > 1);

			$gallerySection.css('--progress', progress);
			$gallerySection.css('--progress-after', progressAfter);
		}

		let getProgressLogo = () => {
			let progress = ((winScrollPosition + winHeight) - sectionOffset) / sectionHeight;
			(progress > 1) && (progress = 1);

			$gallerySection.css('--progress-logo', progress);
		}

		$win.on('load scroll', () => {
			scrollHeight = $(window).scrollTop();
			winScrollPosition = $win.scrollTop() + $('.header')?.outerHeight(true) + $('.js-sticky-submenu')?.outerHeight(true);
			getProgress();
			getProgressLogo();
		}).on('load resize', () => {
			sectionHeight = $gallerySection.outerHeight();
			sectionOffset = $gallerySection.offset().top;

			if (window_width() != winWidth) {
				winHeight = $win.outerHeight() - $('.header')?.outerHeight(true) - $('.js-sticky-submenu')?.outerHeight(true);
				winWidth = window_width();
			}
		}).one('load', function (event) {
			winHeight = $win.outerHeight() - $('.header')?.outerHeight(true) - $('.js-sticky-submenu')?.outerHeight(true);
		});
	}


	//AOS
	function initScrollAnimation() {
		$('.js-fade')
			.attr({
				"data-aos": "fade-up",
				"data-aos-anchor-placement": "top-bottom",
			});

		setTimeout(function () {
			AOS.init({
				duration: 500,
				once: true,
			});
		}, 50);
	}

	$doc.ready(function () {
		$('.js-fade').each(function () {
			let element = this;
			let rect = element.getBoundingClientRect();

			if (rect.top < window.innerHeight && rect.bottom >= 0 && !$(element).hasClass('hero__cta')) {
				$(element).removeClass('js-fade');
			}
		});
	});

	//Cursor
	const $cursor = $('.cursor');
	const $sliders = $('.js-slider-cards, .js-slider-cards-related, .js-slider-articles, .section-text-slider .js-slider-gallery-slides .slider__slide, .section-text-media .js-slider-gallery-slides .slider__slide, .js-slider-full-width, .section-stacked-gallery .js-slider-gallery-slides, .js-slider-testimonials');

	let cursorX = 0;
	let cursorY = 0;
	let cursorYPosition = 0;
	let mouseMove = new Event('mousemove');

	$win.on('mousemove', function (e) {
		updateCursorPosition(e);

		// Check if the cursor is on any of the sliders
		const isCursorInsideSlider = isCursorInsideAnySlider(cursorX, cursorY);

		if (!isCursorInsideSlider) {
			// Cursor is not inside any slider
			$cursor.removeClass('on-slider');
			$body.removeClass('on-slider');
		}
	});

	$doc.on('mousemove', function (e) {
		updateCursorPosition(e);

		// Check if the cursor is on any of the sliders
		const isCursorInsideSlider = isCursorInsideAnySlider(cursorX, cursorY);

		if (!isCursorInsideSlider) {
			// Cursor is not inside any slider
			$cursor.removeClass('on-slider');
			$body.removeClass('on-slider');
		}
	});

	$html.on('mousewheel', function (e) {
		updateCursorPosition(e);

		cursorYPosition = e.pageY - window.scrollY;

		setTimeout(function () {
			const isCursorInsideSlider = isCursorInsideAnySlider(cursorX, cursorY);

			if (!isCursorInsideSlider) {
				// Cursor is not inside any slider
				$cursor.removeClass('on-slider');
				$body.removeClass('on-slider');
			}
		}, 50);
	});

	function isCursorInsideAnySlider(x, y) {
		for (let i = 0; i < $sliders.length; i++) {
			const slider = $sliders[i];
			const rect = slider.getBoundingClientRect();

			if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
				return true;
			}
		}

		return false;
	}

	function isCursorInsideCurrentSlider(x, y, slider) {
		const rect = slider[0].getBoundingClientRect();

		return (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom)
	}

	$win.on('load', function (event) {
		$sliders.each(function () {
			const $slider = $(this);
			const $slickSlides = $(this).hasClass('slider__slide') ? $(this).closest('.slick-list').find('.slick-slide') : $slider.find('.slick-slide');
			const slickSettings = $(this).hasClass('slider__slide') ? $(this).closest('.slider__slides').slick('getSlick') : $slider.slick('getSlick');
			let sliderCenterX = $slider.offset().left + $slider.width() / 2;

			cursorX = event.pageX;
			let isLastSlide = $(slickSettings.$slides[slickSettings.slideCount - 1]).hasClass('is-active');
			let isFirstSlide = slickSettings.currentSlide === 0;
			let isInfiniteSlider = $(this).hasClass('js-slider-cards-related') || $(this).hasClass('js-slider-full-width') || $(this).hasClass('js-slider-testimonials') || ($(this).hasClass('slider__slide') && $(this).closest('.section-stacked-gallery').length <= 0);

			if ($slickSlides.length > slickSettings.options.slidesToShow) {
				$slider.on('mousemove', function (event) {
					cursorX = event.pageX;
				});

				$slider.on('mousemove scroll afterChange', function (event) {
					sliderCenterX = $slider.offset().left + $slider.width() / 2;
					isLastSlide = $(slickSettings.$slides[slickSettings.slideCount - 1]).hasClass('slick-active');
					isFirstSlide = slickSettings.currentSlide === 0;

					if (!isCursorInsideCurrentSlider(cursorX, cursorY, $slider)) {
						$body.removeClass('on-slider');
						$cursor.removeClass('on-slider');
						return;
					}

					if (isInfiniteSlider) {
						if (cursorX < sliderCenterX) {
							$cursor.addClass('on-slider');
							$body.addClass('on-slider');
							$cursor.addClass('is-prev');
						} else if (cursorX > sliderCenterX) {
							$cursor.addClass('on-slider');
							$body.addClass('on-slider');
							$cursor.removeClass('is-prev');
						} else {
							$body.removeClass('on-slider');
							$cursor.removeClass('on-slider');
						}
					} else {
						if (cursorX < sliderCenterX && !isFirstSlide) {
							$cursor.addClass('on-slider');
							$body.addClass('on-slider');
							$cursor.addClass('is-prev');

						} else if (cursorX > sliderCenterX && !isLastSlide) {
							$cursor.addClass('on-slider');
							$body.addClass('on-slider');
							$cursor.removeClass('is-prev');
						} else {
							$body.removeClass('on-slider');
							$cursor.removeClass('on-slider');
						}
					}

					if ($(event.target).is('a') || $(event.target).closest('a').length > 0) {
						$cursor.removeClass('on-slider');
						$body.removeClass('on-slider');
					}
				});
			}

			$slider.on('mouseleave', function (event) {
				$body.removeClass('on-slider');
				$cursor.removeClass('on-slider');
			});
		});
	});


	function updateCursorPosition(e) {
		$cursor.css({
			left: e.clientX,
			top: e.clientY !== undefined ? e.clientY : cursorYPosition,
		});

		cursorX = e.clientX;
		cursorY = e.clientY !== undefined ? e.clientY : cursorYPosition;
	}

	var timer;
	$win.on('scroll', function (event) {
		clearTimeout(timer);

		timer = setTimeout(function () {
			const isCursorInsideSlider = isCursorInsideAnySlider(cursorX, cursorY);

			if (!isCursorInsideSlider) {
				// Cursor is not inside any slider
				$cursor.removeClass('on-slider');
				$body.removeClass('on-slider');
			}
		}, 10);
	});


	//Smooth scroll
	function updateHomeHeaderNavBarPin() {
		var $header = $('.header-tcc--home');
		if (!$header.length) {
			return;
		}
		var $nav = $header.find('.header-tcc__nav-bar');
		var $logoRow = $header.find('.header-tcc__logo-row');
		if (!$nav.length || !$logoRow.length) {
			return;
		}
		if (window_width() <= 1023) {
			$nav.removeClass('header-tcc__nav-bar--pinned');
			$nav.next('.header-tcc__nav-bar-placeholder').css('height', '');
			return;
		}
		var $ph = $nav.next('.header-tcc__nav-bar-placeholder');
		if (!$ph.length) {
			$ph = $('<div class="header-tcc__nav-bar-placeholder" aria-hidden="true"></div>');
			$nav.after($ph);
		}
		var threshold = Math.max(0, $logoRow.outerHeight() || 0);
		var winScrollTop = $win.scrollTop() || 0;
		var lenisScrollTop = (lenis && typeof lenis.scroll === 'number') ? lenis.scroll : 0;
		var st = Math.max(winScrollTop, lenisScrollTop);
		if (st >= threshold) {
			$nav.addClass('header-tcc__nav-bar--pinned');
			$ph.height($nav.outerHeight() || 0);
		} else {
			$nav.removeClass('header-tcc__nav-bar--pinned');
			$ph.height(0);
		}
	}

	function attachHomeNavBarLenisScroll() {
		if (lenis && typeof lenis.on === 'function') {
			if (typeof lenis.off === 'function') {
				lenis.off('scroll', updateHomeHeaderNavBarPin);
			}
			lenis.on('scroll', updateHomeHeaderNavBarPin);
		}
	}

	lenis = new Lenis({
		duration: 1.5,
		smoothWheel: false,
	})

	attachHomeNavBarLenisScroll();
	$win.on('scroll load resize', updateHomeHeaderNavBarPin);
	updateHomeHeaderNavBarPin();

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}

	$doc.on('mouseenter', '.selectric-scroll', function (event) {
		lenis.stop();
		lenis.destroy();
	});

	$doc.on('mouseleave', '.selectric-scroll', function (event) {
		lenis = new Lenis({
			duration: 1.5,
			smoothWheel: false,
		})
		attachHomeNavBarLenisScroll();
	});

	//Sticky sections
	let sumHeight = 0;

	function updateVariables() {
		$('.section-text-media').each(function () {
			const $this = $(this);

			$this.css('--current-height', 'auto');

			const currentHeight = $this.outerHeight(true);
			const windowHeight = $(window).height();

			$this.css('--current-height', currentHeight + 'px');
			$this.css('--sticky-top', '');
			$this.css('--sticky-top', Math.abs(windowHeight - currentHeight) * -1 + 'px');

			sumHeight += currentHeight;
		});
	}

	updateVariables();

	$win.on('resize', function () {
		sumHeight = 0;

		updateVariables();
	});

	//Parallax
	$win.on('scroll load resize', function (event) {
		$('.js-parallax').each(function () {
			const $container = $(this);
			const containerOffsetTop = $container.offset().top;
			const containerHeight = $container.outerHeight(true) - parseInt($container.css('margin-bottom'));
			const mediaScale = 1.15;
			const maxTranslate = ((mediaScale - 1) / 2) * 100;
			const middlePercentage = 0.5;
			const scrollTop = $win.scrollTop();
			const windowHeight = window_height();

			const visibleTop = Math.max(scrollTop, containerOffsetTop);
			const visibleBottom = Math.min(scrollTop + windowHeight, containerOffsetTop + containerHeight);
			const visibleHeight = visibleBottom - visibleTop;
			const percentage = (visibleTop - containerOffsetTop + visibleHeight / 2) / containerHeight;
			let translateY = 0;

			if (visibleTop < containerOffsetTop + containerHeight && visibleBottom > containerOffsetTop) {
				const scrollPercentage = (scrollTop + windowHeight - containerOffsetTop) / (containerHeight + windowHeight);
				translateY = (scrollPercentage - middlePercentage) * 2 * 10;
			} else if (visibleBottom < containerOffsetTop) {
				translateY = -maxTranslate;
			} else if (visibleTop > containerOffsetTop + containerHeight) {
				translateY = maxTranslate;
			}

			if (translateY < -maxTranslate) {
				translateY = -maxTranslate
			}

			if (translateY > maxTranslate) {
				translateY = maxTranslate;
			}

			$container.find('img').css('transform', `translate3d(0, ${translateY}%, 0) scale(${mediaScale})`);
		});
	});


	//Resize picture-sizes
	function calcMediaHeight() {
		const $mediaContainer = $('.js-images-resize');

		if ($mediaContainer.length > 0 && !window.matchMedia("(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)").matches) {
			$mediaContainer.each(function (index, el) {
				var maxMediaHeight = 0;
				var $media = $(el).find('.card .card__media > *');
				var $slickSlider = $(el).find('.slider__slides.slick-initialized');

				$media.each(function () {
					$(this).parent().height('');
				});

				setTimeout(function () {
					$media.each(function () {
						var mediaHeight = $(this).height();
						maxMediaHeight = Math.ceil(Math.max(maxMediaHeight, mediaHeight));
					});

					$media.parent().height(maxMediaHeight);

					$slickSlider.slick('setPosition');
				}, 100);
			});
		} else {
			$mediaContainer.each(function (index, el) {
				$(el).find('.card .card__media > *').each(function () {
					$(this).parent().css('height', '');
				});
			});
		}
	}

	calcMediaHeight();

	$win.on('load', function (event) {
		calcMediaHeight();
	});

	$win.on('resize', function (event) {
		calcMediaHeight();
	});


	requestAnimationFrame(raf)
})(jQuery, window, document);
